import './submissions_table.css';
import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import {makeStyles} from '@mui/styles';
import RadialCharts_submissionsState from '../radialCharts_submissionsState/radialCharts_submissionsState';

function submission_treated(stat){
    return(
      <>
        {
         stat == 0
         ?<Button variant="contained" className="status_deny">refusée</Button>
         :stat == 1?<Button variant="contained" className="status_success">adjugée</Button>
                    :<Button variant="contained" className="status_waiting">en cours</Button>
        }
      </>
  
    );
  }

  

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

const columns = [
    { id: 'objet', numeric: false, disablePadding: false, label: 'Objet d\'achat',align: 'left' },
    { id: 'financial_score', numeric: true, disablePadding: false, label: 'Score financier',align: 'left'  },
    { id: 'technical_score', numeric: true, disablePadding: false, label: 'Score technique' ,align: 'left' },
    { id: 'dateDemande', numeric: true, disablePadding: false, label: 'Date de soumission' ,align: 'left' },
    { id: 'accord', numeric: true, disablePadding: false, label: 'Accord',align: 'center'}
];

function Submissions({submissions}){
    
    return(
        <>
        {
            submissions.map((submission,index1) => (
                <TableRow key={submission.offer_id+"last_submission_col"+index1}>
                    <TableCell align="left">{submission.object}</TableCell>
                    <TableCell align="center">
                            {submission.financial_score}
                    </TableCell>
                    <TableCell align="center">
                            {submission.technical_score}
                    </TableCell>
                    <TableCell align="left">{(new Date(submission.date)).toLocaleString()}</TableCell>
                    <TableCell align="center">
                        {submission_treated(submission.accord)}
                    </TableCell>
                </TableRow>                
             ))
        }
        </>
    );
}


const Last_submissions = ({categories,data}) => {

    const classes = useStyles();
    const [show_elemnts,setShowing_elements] = useState(false);

    function getCategorieById(id){
        var categorie="";
        categories.map((catg)=>{
            if(catg.id_category == id) categorie = catg.name;
        })
        return categorie;
    }

  return (
    <>
    {
      show_elemnts!==true
        ?<RadialCharts_submissionsState setShowing_elements={setShowing_elements} elements_number={data.count} count_accorded={data.count_accorded} count_waiting={data.count_waiting} count_lost={data.count_lost} fontColor="rgb(104 56 211)" />
        :<TableContainer className="submissions_table" component={Paper} onContextMenu={(e) => {e.preventDefault();setShowing_elements(false)}} style={{cursor:'pointer'}} onTouchStartCapture={(e)=>{e.stopPropagation();setShowing_elements(false)}} >
            <Table className={classes.table} aria-label="sticky table">
                <TableHead>
                <TableRow>
                    {
                        columns.map((column) => (
                            <TableCell key={column.id} align={column.align}>{column.label}</TableCell>
                        ))
                    }
                </TableRow>
                </TableHead>
                <TableBody>
                {
                    data.last_submissions.length!=0
                    ?
                    <>
                        <Submissions submissions={data.last_submissions} getCategorieById={getCategorieById} />
                    </>
                            
                    :<div style={{margin:"10px",fontSize:".8rem",width:'100%', textAlign:"center",alignContent:"center"}}>Aucun offre disponible</div>
                }
                </TableBody> 
            </Table>
        </TableContainer>
    }
    </>
  );
}

export default React.memo(Last_submissions);
